import type { FC, ReactNode } from 'react'
import type { Faq } from '@/types'

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger
} from '@/components/ui/accordion'

interface FaqListProps {
    faqs: Array<Faq>
}

export const FaqList: FC<FaqListProps> = ({ faqs }): ReactNode => {
    return (
        <Accordion className='border-y border-border'>
            {faqs.map(faq => (
                <AccordionItem key={faq.id} value={faq.id} className='border-border'>
                    <AccordionTrigger className='gap-6 py-6 text-lg font-semibold tracking-tight hover:no-underline sm:text-xl **:data-[slot=accordion-trigger-icon]:mt-1.5 **:data-[slot=accordion-trigger-icon]:size-5 **:data-[slot=accordion-trigger-icon]:text-primary'>
                        <span className='font-heading' data-mdlfy-cms={`faqs:${faq.id}:question`}>
                            {faq.question}
                        </span>
                    </AccordionTrigger>

                    <AccordionContent className='pb-6 text-base leading-relaxed text-muted-foreground'>
                        <p className='max-w-3xl' data-mdlfy-cms={`faqs:${faq.id}:answer`}>
                            {faq.answer}
                        </p>
                    </AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    )
}
